import { find, isEmpty, map, range } from 'lodash/fp';

export type Tree<T extends string> = Readonly<{
  id: T;
  branches?: ReadonlyArray<Tree<T>>;
  content: Record<string, string>;
}>;

// eslint-disable-next-line no-unused-vars
type GetBranch<T extends string> = (decisions: ReadonlyArray<T>, depth: number) => Tree<T> | null;

const getBranch = <T extends string>(initialTree: Tree<T>): GetBranch<T> => {
  if (isEmpty(initialTree)) {
    return () => null;
  }

  return (decisions, depth) => {
    if (depth > decisions.length) {
      return null;
    }

    let branch = initialTree;
    // eslint-disable-next-line lodash-fp/no-unused-result
    map(
      (current) => {
        const decision = decisions[current];
        branch = (find({ id: decision }, branch?.branches) as Tree<T>) ?? null;
      },
      range(0, depth),
    );
    return branch;
  };
};

export default getBranch;
